<template>
    <div class="file-view">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <iframe
                        :src="fileUrl"
                        width="100%"
                        height="600px"
                        frameborder="0"
                        scrolling="yes"
                        class="rounded-xl"
                    ></iframe>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    props: ['iid'],
    data: () => ({
        fileUrl: '',
    }),
    async created() {
        try {
            // A URL no backend que retorna o arquivo
            this.fileUrl = `/arquivo/${this.iid}`;
        } catch (error) {
            console.error('Erro ao carregar o arquivo:', error);
        }
    },
};
</script>
